// extracted by mini-css-extract-plugin
export default {"overlay":"RedirectComponent_overlay--xxP","wrapper":"RedirectComponent_wrapper--yze"};